import { render, staticRenderFns } from "./ObrigadoMobile.vue?vue&type=template&id=be0b5a98&scoped=true"
import script from "./ObrigadoMobile.vue?vue&type=script&lang=js"
export * from "./ObrigadoMobile.vue?vue&type=script&lang=js"
import style0 from "./ObrigadoMobile.vue?vue&type=style&index=0&id=be0b5a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0b5a98",
  null
  
)

export default component.exports